"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursiveOperationSessionRpcRemote = void 0;
const utils_1 = require("@streamr/utils");
const RpcRemote_1 = require("../contact/RpcRemote");
const logger = new utils_1.Logger(module);
class RecursiveOperationSessionRpcRemote extends RpcRemote_1.RpcRemote {
    sendResponse(routingPath, closestConnectedNodes, dataEntries, noCloserNodesFound) {
        const report = {
            routingPath,
            closestConnectedNodes,
            dataEntries,
            noCloserNodesFound
        };
        this.getClient().sendResponse(report, this.formDhtRpcOptions()).catch((_e) => {
            logger.trace('Failed to send RecursiveOperationResponse');
        });
    }
}
exports.RecursiveOperationSessionRpcRemote = RecursiveOperationSessionRpcRemote;
//# sourceMappingURL=RecursiveOperationSessionRpcRemote.js.map